// extracted by mini-css-extract-plugin
export default {"header":"classes@desktop_header__Fsacu","title":"classes@desktop_title__JNYZA","subtitle":"classes@desktop_subtitle__nP2Rv"};